import React, { useEffect, useState } from "react";
import API from "../api";
import "./Sidebar.css";
import { NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";


export default function Sidebar() {
  const [menus, setMenus] = useState([]);
  const [panel, setpanel] = useState("showpanel");
  const role = localStorage.getItem("role"); // get logged-in role
  useEffect(() => {
    loadMenus();
  }, []);


  const loadMenus = async () => {
    const res = await API.get("/menus");
    console.log("Menus from API:", res.data);
    const userRole = Number(localStorage.getItem("role"));

    const filteredMenus = res.data.filter(menu =>
      menu.Access_Role &&
      menu.Access_Role
        .replace(/\[|\]/g, "")
        .split(",")
        .map(Number)
        .includes(userRole)
    );
    console.log("Filtered Menus:", filteredMenus);
    console.log("User Role:", localStorage.getItem("role"));
    setMenus(filteredMenus);
  };
  const sidepanel = () => {
    if (panel === "showpanel") {
      setpanel("panel");
    } else {
      setpanel("showpanel");
    }
  };
  const navigate = useNavigate();

  const logout = () => {
    localStorage.removeItem("token");
    navigate("/");
  };
  const handleLogout = () => {
    logout();
  };

  return (
    <div className="sidebar-container">
      {/* LOGO */}
      <div className="sidebar-header">
        <img src="/Softmate-Logo1.png" alt="Softmate" />
        {/* <h4>Softmate</h4> */}
      </div>

      {/* MENU */}
      <div className="menu-list">
        {menus.map((m) => (
          // <NavLink
          //   key={m.Menu_ID}
          //   to={m.Link}
          //   className={({ isActive }) =>
          //     isActive ? "menu-item active" : "menu-item"
          //   }
          // >
          //   {/* <img src={m.Dashboard-32} className="menu-icon" alt="" /> */}
          //   <span>{m.Menu_Name}</span>
          // </NavLink>
          <NavLink
            key={m.Menu_ID}
            to={
              role === "lead"
                ? m.Link.replace("/AdminDashboard", "/LeadDashboard")
                : m.Link
            }
            className={({ isActive }) =>
              isActive ? "menu-item active" : "menu-item"
            }
          >
            <span>{m.Menu_Name}</span>
          </NavLink>
        ))}
      </div>

      {/* LOGOUT */}
      <div className="sidebar-footer">
        <button className="logout-btn" onClick={handleLogout}>
          <i className="fa fa-sign-out"></i> Logout
        </button>
      </div>

      {/* BACKGROUND IMAGE */}
      <img src="/Corner-web-img.png" className="sidebar-bg" alt="" />
    </div>

  );
}
